import {combineValidators, required, maxLength, isPrice, isImage, isValidString, isValidNumber} from "../Validators";

export const EditMenuItemScheme = {
  name: combineValidators(required, isValidString),
  description: combineValidators(required, maxLength(500)),
  price: combineValidators(required, isPrice, isValidNumber),
  picturePath: isImage,
};